var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemsql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 184,
    viewBox: "0 0 256 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.8781 13.9976C66.7493 6.05442 59.6893 1.00993 51.2216 0.0107422C50.2112 0.0341046 49.2009 0.113177 48.2013 0.271322C17.5197 5.12529 0.780258 48.3815 0 91.638C0.780258 134.894 17.5197 178.15 48.2031 183.004C49.2027 183.163 50.2112 183.242 51.2234 183.265C59.691 182.266 66.7493 177.219 72.8799 169.278C56.8041 151.53 49.0229 120.178 48.5087 91.638C49.0211 63.0978 56.8018 31.7458 72.8781 13.9976Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.618 0.271363C206.619 0.113218 205.61 0.034145 204.598 0.0107826C204.402 0.00718843 204.206 0 204.01 0C197.888 0 165.117 0.00359421 157.672 0C157.428 0 157.184 0.00718843 156.939 0.0143768C162.653 0.569682 167.913 2.41172 172.69 5.34818C176.422 7.64309 179.836 10.567 182.943 13.9976C199.019 31.7458 206.8 63.0982 207.314 91.6379C206.8 120.178 199.019 151.53 182.943 169.278C179.836 172.707 176.424 175.633 172.69 177.927C167.913 180.864 162.653 182.706 156.939 183.261C157.184 183.269 157.428 183.276 157.672 183.276C165.117 183.272 197.888 183.276 204.01 183.276C204.206 183.276 204.402 183.271 204.598 183.265C205.608 183.242 206.619 183.163 207.618 183.004C238.299 178.149 255.041 134.894 255.821 91.6379C255.041 48.3816 238.301 5.12534 207.618 0.271363Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.589 156.719C140.392 161.403 138.147 165.592 135.824 169.341C135.434 169.969 135.5 170.776 135.978 171.339C141.133 177.39 146.974 181.51 153.721 182.898C154.782 183.115 155.857 183.228 156.938 183.264C162.651 182.709 167.911 180.867 172.688 177.93C176.42 175.635 179.835 172.712 182.941 169.281C173.379 156.89 166.078 137.451 159.215 115.332C158.967 114.531 157.829 114.532 157.586 115.338C153.18 129.98 148.403 144.325 142.589 156.719Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8792 13.9995C82.4419 26.3905 89.7425 45.8298 96.6049 67.9483C96.8529 68.75 97.9914 68.7483 98.2336 67.9431C102.642 53.3003 107.419 38.9558 113.233 26.5612C115.43 21.8779 117.676 17.6889 119.998 13.9401C120.387 13.3129 120.324 12.5042 119.844 11.9435C114.689 5.8909 108.848 1.77015 102.099 0.382783C101.035 0.163537 99.9505 0.0503189 98.863 0.0143768C98.6259 0.00718843 98.3865 0.0017971 98.1477 0.0017971C90.7029 0.00359421 57.9322 0.0017971 51.8105 0C51.6145 0 51.4186 0.00539131 51.2227 0.0107826C59.6903 1.01177 66.7504 6.05624 72.8792 13.9995Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.692 5.34455C167.915 2.40808 162.655 0.566048 156.942 0.0107422C155.861 0.0448872 154.784 0.158105 153.725 0.377351C127.859 5.69139 115.336 51.1564 103.631 91.6346C94.5158 123.181 85.7446 152.606 72.8792 169.274C66.7504 177.216 59.6903 182.262 51.2227 183.262C51.4186 183.265 51.6145 183.272 51.8105 183.272C57.9322 183.272 90.7029 183.268 98.1477 183.272C98.3923 183.272 98.6368 183.265 98.8813 183.258C99.9614 183.224 101.039 183.11 102.098 182.891C127.964 177.575 140.486 132.111 152.192 91.6323C161.307 60.086 170.078 30.6604 182.944 13.9922C179.839 10.5633 176.425 7.63944 172.692 5.34455Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 36.4223,
    y1: -0.498677,
    x2: 36.4223,
    y2: 183.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#F46BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#D945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#C527FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#B611FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#AD04FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#AA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#A601FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9A04F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#8608DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#690EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#4516A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 206.383,
    y1: 0,
    x2: 206.383,
    y2: 183.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#F46BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#D945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#C527FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#B611FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#AD04FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#AA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#A601FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9A04F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#8608DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#690EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#4516A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 159.251,
    y1: 183.814,
    x2: 159.251,
    y2: 113.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#F268FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#D843FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#C426FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#B611FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#AD04FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 85.7245,
    y1: 69.1114,
    x2: 85.7245,
    y2: -0.475325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#A601FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#9A04F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#8608DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#690EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#4516A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311B92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 117.079,
    y1: 183.298,
    x2: 117.079,
    y2: -0.160795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#F46BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#D945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#C527FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#B611FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#AD04FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#AA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#A601FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9A04F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#8608DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#690EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#4516A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311B92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemsql);
export default __webpack_public_path__ + "static/media/memsql.6bfaf0ce6d5a42e58e08e01fd0d7f3ec.svg";
export { ForwardRef as ReactComponent };